import React, { Component, Fragment } from "react";
import { Route, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Switch } from "react-router";
import * as R from "ramda";
import { helmetRequest } from "../../../app/state/actions";
import Helmet from "react-helmet";

import MeLoading from "../../../app/components/meLoading";

import { doRequestMe, doLogout } from "../../../app/state/actions";

import Header from "../../components/header";
import Finish from "./finish";
import Identify from "./identify";
import Pay from "./pay";

export const IDENTIFY_PATH = "/assine/identificacao";
export const PAY_PATH = "/assine/pagamento";
export const FINISH_PATH = "/assine/finalizacao";

class BuyFlow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cupomQuery: ""
    };

    this.onLogout = this.onLogout.bind(this);
  }

  componentDidMount() {
    const { doRequestMe, helmetRequest, location } = this.props;

    const search = this.props.location.search;
    let cupomQuery = "";
    if (search) {
      const splitted = search.replace("?", "").split("=");
      const keyIndex = splitted.findIndex(it => it === "cupom");
      const valueIndex = keyIndex + 1;
      if (keyIndex > -1) {
        cupomQuery = splitted[valueIndex];
      }
    }

    this.setState({
      cupomQuery
    });

    doRequestMe().then(({ situation }) => {
      if (situation !== "guest") {
        this.props.history.replace("/assine/pagamento");
        // this.props.history.replace("/assine/finalizacao");
      }
    }, R.always());

    helmetRequest({
      title: "Fluxo de Compra",
      canonical: location.pathname
    });
  }

  getStepFromPath() {
    const { location } = this.props;
    switch (location.pathname) {
      case IDENTIFY_PATH:
        return 0;
      case PAY_PATH:
        return 1;
      case FINISH_PATH:
        return 2;
      default:
        return 0;
    }
  }

  onLogout() {
    const { doLogout, history } = this.props;

    doLogout();
    history.replace("/assine");
  }

  render() {
    const { location, userName, isRequestingMe, data } = this.props;
    const step = this.getStepFromPath();

    return (
      <Fragment>
        <Helmet>
          <title>{data.helmet.title}</title>
          {/* <link rel="canonical" href={data.helmet.canonical} /> */}

          {/* Facebook Pixel Code */}
          <script>
            {`
            !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '254341104760439');
              fbq('track', '${location.pathname === FINISH_PATH ? "Purchase" : "InitiateCheckout"}');
            `}
          </script>

          <noscript>
            {`
            <img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=254341104760439&ev=PageView&noscript=1" />
            `}
          </noscript>
          {/* End Facebook Pixel Code */}

          {/* Global site tag (gtag.js) - AdWords: 1010575996 */}
          <script async src="https://www.googletagmanager.com/gtag/js?id=AW-1010575996" />
          <script>
            {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'AW-1010575996');
            `}
          </script>
          {/* Global site tag (gtag.js) - AdWords: 1010575996 */}
        </Helmet>
        <Header step={step} name={userName} onLogout={this.onLogout} showTimeline="true" showSubTitle="true" />

        {isRequestingMe ? (
          <MeLoading />
        ) : (
          <Switch>
            <Route path={PAY_PATH} render={() => <Pay cupomQuery={this.state.cupomQuery} />} />
            <Route path={FINISH_PATH} render={Finish} />
            <Route render={() => <Identify />} />} />
          </Switch>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state.account,
    ...state.app,
    isRequestingMe: state.app.ui.isRequestingMe,
    userName: state.app.data.user.email
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      doRequestMe,
      doLogout,
      helmetRequest
    },
    dispatch
  );
};

const Routered = withRouter(connect(mapStateToProps, mapDispatchToProps)(BuyFlow));

Routered.displayName = "BuyFlow";

export default Routered;
